import React from 'react';

const defaults = { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' };

export const IconHome = (p) => (
  <svg {...defaults} {...p}><path d="M3 10.5 12 3l9 7.5" /><path d="M5 10v10h14V10" /></svg>
);

export const IconProjects = (p) => (
  <svg {...defaults} {...p}><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" /></svg>
);

export const IconSettings = (p) => (
  <svg {...defaults} {...p}><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" /></svg>
);

export const IconOverview = (p) => (
  <svg {...defaults} {...p}><path d="M4 19V5" /><path d="M4 19h16" /><path d="M8 15v-4" /><path d="M12 15V9" /><path d="M16 15v-7" /></svg>
);

export const IconRequirements = (p) => (
  <svg {...defaults} {...p}><path d="M8 6h12" /><path d="M8 12h12" /><path d="M8 18h12" /><path d="M4 6h.01" /><path d="M4 12h.01" /><path d="M4 18h.01" /></svg>
);

export const IconJira = (p) => (
  <svg {...defaults} {...p}><path d="M12 3 4 12l8 9 8-9-8-9z" /><path d="M12 8v8" /></svg>
);

export const IconTestCase = (p) => (
  <svg {...defaults} {...p}><path d="M9 5h11" /><path d="M9 12h11" /><path d="M9 19h11" /><path d="M4 5h.01" /><path d="M4 12h.01" /><path d="M4 19h.01" /></svg>
);

export const IconSuite = (p) => (
  <svg {...defaults} {...p}><path d="M4 7h16v12H4z" /><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>
);

export const IconPlan = (p) => (
  <svg {...defaults} {...p}><rect x="4" y="4" width="16" height="16" rx="2" /><path d="M8 9h8" /><path d="M8 13h8" /><path d="M8 17h5" /></svg>
);

export const IconRun = (p) => (
  <svg {...defaults} {...p}><circle cx="12" cy="12" r="9" /><path d="M10 8.5 16 12l-6 3.5z" fill="currentColor" stroke="none" /></svg>
);

export const IconSchedule = (p) => (
  <svg {...defaults} {...p}><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 10h18" /><path d="M8 3v4" /><path d="M16 3v4" /></svg>
);

export const IconReports = (p) => (
  <svg {...defaults} {...p}><path d="M4 19V5" /><path d="M4 19h16" /><path d="M8 16l3-4 3 2 4-6" /></svg>
);

export const IconIntelligence = (p) => (
  <svg {...defaults} {...p}><path d="M12 3a6 6 0 0 1 4 10.5V17H8v-3.5A6 6 0 0 1 12 3z" /><path d="M9 21h6" /></svg>
);

export const IconEnv = (p) => (
  <svg {...defaults} {...p}><circle cx="12" cy="12" r="3" /><path d="M12 2v3" /><path d="M12 19v3" /><path d="M2 12h3" /><path d="M19 12h3" /></svg>
);

export const IconIntegrations = (p) => (
  <svg {...defaults} {...p}><path d="M10 13a5 5 0 0 0 7.07 0l1.41-1.41a5 5 0 0 0-7.07-7.07L10 5.93" /><path d="M14 11a5 5 0 0 0-7.07 0L5.52 12.4a5 5 0 0 0 7.07 7.07L14 18.07" /></svg>
);

export const IconRepo = (p) => (
  <svg {...defaults} {...p}><path d="M6 3v18" /><circle cx="6" cy="6" r="2" /><circle cx="6" cy="12" r="2" /><circle cx="6" cy="18" r="2" /><path d="M8 6h7a3 3 0 0 1 0 6H8" /><path d="M8 12h8" /></svg>
);

export const IconAutomation = (p) => (
  <svg {...defaults} {...p}><path d="M12 2v4" /><path d="M12 18v4" /><path d="m4.9 4.9 2.8 2.8" /><path d="m16.3 16.3 2.8 2.8" /><path d="M2 12h4" /><path d="M18 12h4" /><path d="m4.9 19.1 2.8-2.8" /><path d="m16.3 7.7 2.8-2.8" /><circle cx="12" cy="12" r="3" /></svg>
);

export const IconSearch = (p) => (
  <svg {...defaults} {...p}><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
);

export const IconBell = (p) => (
  <svg {...defaults} {...p}><path d="M6 9a6 6 0 1 1 12 0c0 7 3 7 3 7H3s3 0 3-7" /><path d="M10 19a2 2 0 0 0 4 0" /></svg>
);

export const IconChevron = (p) => (
  <svg {...defaults} {...p}><path d="m6 9 6 6 6-6" /></svg>
);

export const IconLogout = (p) => (
  <svg {...defaults} {...p}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="M16 17l5-5-5-5" /><path d="M21 12H9" /></svg>
);

export const IconData = (p) => (
  <svg {...defaults} {...p}><ellipse cx="12" cy="5" rx="8" ry="3" /><path d="M4 5v6c0 1.7 3.6 3 8 3s8-1.3 8-3V5" /><path d="M4 11v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6" /></svg>
);

export const IconEpics = (p) => (
  <svg {...defaults} {...p}><path d="M4 6h16v4H4z" /><path d="M4 14h10v4H4z" /></svg>
);
